import Alert from "common/components/ui/Alert";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { SubscriptionStatus } from "common/types";

function getTransitionMessage(
  subscriptionStatus: SubscriptionStatus | null,
  lifetimeLicenseCount: number,
): string | undefined {
  const hasLifetimeSeats = lifetimeLicenseCount > 0;
  const isOutreachActive =
    subscriptionStatus === "active" || subscriptionStatus === "non_renewing";

  if (subscriptionStatus === "in_trial") {
    return "Upgrading to Agency will end your Outreach Free trial and move your workspace to the Agency plan today. Your assigned seats will stay as they are.";
  }

  if (isOutreachActive && hasLifetimeSeats) {
    return "Your workspace will move from Outreach to Agency today. Your assigned seats will stay as they are. Any lifetime seats on your workspace will be suspended while you're on the Agency plan.";
  }

  if (isOutreachActive) {
    return "Your workspaces will move from Outreach to Agency today. Your assigned seats will stay as they are.";
  }

  if (hasLifetimeSeats) {
    return "Upgrading to Agency will suspend your lifetime seats while your workspace is on the Agency plan.";
  }

  return undefined;
}

export default function AgencyPurchaseAlertBanners() {
  const { subscription_status, lifetime_license_count } =
    useSelectedWorkspaceContext();

  const transitionMessage = getTransitionMessage(
    subscription_status,
    lifetime_license_count,
  );

  if (transitionMessage) {
    return <Alert variant="gradient">{transitionMessage}</Alert>;
  }
}
